import { memo } from 'react';
import { ColIdType } from '../../../../../../types';
import CellDataContainer from '../cellDataContainer';
import { Checkbox } from 'semantic-ui-react';
import { useChangeColumnMetadata, useIsColumnImportCandidate } from '../../../../../../stores/metadataStore';

type ColumnInclusionControlPropsType = {
    colId: ColIdType;
};
const ColumnInclusionControl = memo(function ColumnInclusionControl({ colId }: ColumnInclusionControlPropsType) {
    const isImportCandidate = useIsColumnImportCandidate(colId);
    const changeColMetadata = useChangeColumnMetadata();
    return (
        <CellDataContainer className="flex-justify-center">
            <Checkbox
                checked={isImportCandidate}
                onChange={() => changeColMetadata(colId, { importCandidate: !isImportCandidate })}
            />
        </CellDataContainer>
    );
});

export default ColumnInclusionControl;
